webpackJsonp([2],[
/* 0 */,
/* 1 */,
/* 2 */,
/* 3 */,
/* 4 */,
/* 5 */,
/* 6 */,
/* 7 */,
/* 8 */,
/* 9 */,
/* 10 */,
/* 11 */,
/* 12 */,
/* 13 */,
/* 14 */,
/* 15 */,
/* 16 */,
/* 17 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getAccountConfig = exports.getData = exports.getProdDataListPage = exports.getDataListPage = exports.getCompanyList = exports.getJobList = exports.getDepartmentList = exports.requestLogin = exports.getUploadPath = undefined;

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(34);

var _axios2 = _interopRequireDefault(_axios);

var _http = __webpack_require__(32);

var _http2 = _interopRequireDefault(_http);

var _userutils = __webpack_require__(68);

var _userutils2 = _interopRequireDefault(_userutils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var queryString = __webpack_require__(237);


var base = '';
var requesttool = _http2.default;

var prefix = '';
var product_base = '/api' + prefix;

var product_request_tool = _axios2.default;

var getUploadPath = exports.getUploadPath = function getUploadPath() {
    return product_base + '/posts';
};

var postRequest = function postRequest(vueobj, path, params) {
    if (params === undefined) params = {};
    params['adminUid'] = _userutils2.default.getUserId();
    return product_request_tool.post(path, queryString.stringify(params)).then(function (res) {
        if (res.data.code !== 0) {
            var msg = "请求失败，错误码" + res.data.code;
            if (res.data.message) {
                msg = res.data.message;
            }

            return _promise2.default.reject('请求失败');
        } else {
            return res.data.data;
        }
    });
};

var requestLogin = exports.requestLogin = function requestLogin(params) {
    return product_request_tool.get(product_base + '/login', { params: params });
};

var getDepartmentList = exports.getDepartmentList = function getDepartmentList(params) {
    return product_request_tool.get(product_base + '/department/get/all', { params: params });
};
var getJobList = exports.getJobList = function getJobList(params) {
    return requesttool.get(base + '/duty/listpage', { params: params });
};
var getCompanyList = exports.getCompanyList = function getCompanyList(params) {
    return requesttool.get(base + '/company/listpage', { params: params });
};

var getDataListPage = exports.getDataListPage = function getDataListPage(entityname, params) {
    return product_request_tool.get(product_base + '/' + entityname + '/get/all', { params: params });
};
var getProdDataListPage = exports.getProdDataListPage = getDataListPage;
var getData = exports.getData = function getData(entityname, params) {
    return product_request_tool.get(product_base + '/' + entityname + '/get', { params: params });
};

var getAccountConfig = exports.getAccountConfig = function getAccountConfig() {
    return product_request_tool.get(product_base + '/account/get/type_config');
};

/***/ }),
/* 18 */,
/* 19 */,
/* 20 */,
/* 21 */,
/* 22 */,
/* 23 */,
/* 24 */,
/* 25 */,
/* 26 */,
/* 27 */,
/* 28 */,
/* 29 */,
/* 30 */,
/* 31 */,
/* 32 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _axios = __webpack_require__(34);

var _axios2 = _interopRequireDefault(_axios);

var _qs = __webpack_require__(234);

var _qs2 = _interopRequireDefault(_qs);

var _elementUi = __webpack_require__(59);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var http = _axios2.default.create({});

http.interceptors.response.use(function (response) {
    var code = response.data.code;
    var data = response.data;
    console.log("receive response => ");
    console.log(response);
    if (response.status === 302) {
        console.log("302跳转");
        _elementUi.MessageBox.alert('点击确定跳转到登录界面', '登录已过期', {
            type: 'warning',
            confirmButtonText: '确定'
        });
        location.href = response.headers.Location;
    } else {
        console.log("收到200响应");
        if (response.status === 200) {
            if (code !== 0) {
                console.log("code不等于0,直接展示错误消息");
                _elementUi.MessageBox.alert(data.msg, '服务器响应异常', {
                    type: 'error',
                    confirmButtonText: '确定'
                });
                return response;
            } else {
                console.log("响应成功，直接返回data数据");
                return response;
            }
        } else {
            console.log("服务器状态码不为200,返回response,留待程序自行处理");
            return response;
        }
    }
}, function (error) {
    console.log('服务器响应错误');
    console.log('error.message => ');
    console.log(error.message);
    if (error.request) {
        console.log("请求信息:");
        console.log(error.request);
    }
    var return_error = error;
    if (error.response) {
        console.log("响应内容:");
        console.log(error.response);
        if (error.response.status === 302) {
            _elementUi.MessageBox.alert(error.message, '登录过期，请刷新页面重新登录', {
                type: 'error',
                confirmButtonText: '确定'
            });
        }
        return_error = error.response;
    } else {
        console.log('没有响应内容');
        return_error = _promise2.default.reject(error);
    }
    _elementUi.MessageBox.alert(error.message, '服务器响应错误', {
        type: 'error',
        confirmButtonText: '确定'
    });
    return return_error;
});
console.log("random");
console.log(http.config);
exports.default = http;

/***/ }),
/* 33 */
/***/ (function(module, exports) {

module.exports = Vue;

/***/ }),
/* 34 */,
/* 35 */,
/* 36 */,
/* 37 */,
/* 38 */,
/* 39 */,
/* 40 */,
/* 41 */,
/* 42 */,
/* 43 */,
/* 44 */,
/* 45 */,
/* 46 */,
/* 47 */,
/* 48 */,
/* 49 */,
/* 50 */,
/* 51 */,
/* 52 */,
/* 53 */,
/* 54 */,
/* 55 */,
/* 56 */,
/* 57 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _Login = __webpack_require__(241);

var _Login2 = _interopRequireDefault(_Login);

var _ = __webpack_require__(239);

var _2 = _interopRequireDefault(_);

var _Home = __webpack_require__(240);

var _Home2 = _interopRequireDefault(_Home);

var _Main = __webpack_require__(242);

var _Main2 = _interopRequireDefault(_Main);

var _team = __webpack_require__(134);

var _team2 = _interopRequireDefault(_team);

var _ParseExcel = __webpack_require__(248);

var _ParseExcel2 = _interopRequireDefault(_ParseExcel);

var _UserHealthList = __webpack_require__(243);

var _UserHealthList2 = _interopRequireDefault(_UserHealthList);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var routes = [{
    path: '/login',
    component: _Login2.default,
    hidden: true
}, {
    path: '/404',
    component: _2.default,
    hidden: true
}, {
    path: '/main',
    component: _Main2.default,
    hidden: true
}, {
    path: '/',
    component: _Home2.default,
    name: '主页',
    iconCls: 'el-icon-message',
    hidden: true,
    children: [{ path: '/', component: _Main2.default, name: '主页', hidden: true }]
}, {
    path: '/',
    name: '用户',
    component: _Home2.default,
    iconCls: 'fa fa-id-card-o',
    children: [{ path: '/user/list', component: _ParseExcel2.default, name: 'excel处理', meta: _team2.default }]
}, {
    path: '*',
    hidden: true,
    redirect: { path: '/404' }
}];

exports.default = routes;

/***/ }),
/* 58 */,
/* 59 */
/***/ (function(module, exports) {

module.exports = ELEMENT;

/***/ }),
/* 60 */,
/* 61 */,
/* 62 */,
/* 63 */,
/* 64 */,
/* 65 */,
/* 66 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    fieldmap: [{
        key: "num",
        name: "团号",
        width: 100
    }, {
        key: "title",
        name: "标题",
        width: 200
    }]
};


function getConfig() {
    return {
        fieldmap: [{
            key: "num",
            name: "团号",
            width: 100
        }, {
            key: "title",
            name: "标题",
            width: 200
        }]
    };
}

exports.getConfig = getConfig;

/***/ }),
/* 67 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.accountAllotType = exports.teamStatusEnum = exports.accountStatus = exports.accountStatusEnum = undefined;

var _typeof2 = __webpack_require__(158);

var _typeof3 = _interopRequireDefault(_typeof2);

var _values = __webpack_require__(72);

var _values2 = _interopRequireDefault(_values);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    entityName: {
        ACCOUNT: "account"
    },
    dutyType: {
        daoyou: { id: 1, name: "导游员" },
        jidiao: { id: 2, name: "计调员" },
        caiwu: { id: 3, name: "财务员" },
        jingli: { id: 4, name: "经理" },
        getArray: function getArray() {
            return _getArray(this);
        },
        getName: function getName(id) {
            return _getName(this, id);
        }
    }
};


var _getArray = function _getArray(obj) {
    return (0, _values2.default)(obj).filter(function (item) {
        return (typeof item === "undefined" ? "undefined" : (0, _typeof3.default)(item)) == (0, _typeof3.default)({});
    });
};

var _getName = function _getName(obj, id) {
    return obj.getArray().find(function (item) {
        return item.id == id;
    }).name;
};

var accountStatusEnum = exports.accountStatusEnum = {
    weitongguo_jidiao: { id: 1, name: "未通过(计调)" },
    tongguo_jidiao: { id: 2, name: "通过(计调)" },
    weitongguo_caiwu: { id: 3, name: "未通过(财务)" },
    tongguo_caiwu: { id: 4, name: "通过(财务)" },
    weitongguo_jingli: { id: 5, name: "未通过" },
    tongguo_jingli: { id: 5, name: "通过" },
    getArray: function getArray() {
        return _getArray(this);
    },
    getName: function getName(id) {
        return _getName(this, id);
    }
};
var accountStatus = exports.accountStatus = accountStatusEnum.getArray();

var teamStatusEnum = exports.teamStatusEnum = {
    quanbu: { id: 0, name: "全部" },
    weishangtuan: { id: 1, name: "未上团" },
    shangtuanzhong: { id: 2, name: "上团中" },
    yixiatuan: { id: 3, name: "已下团" },
    weishenhe_jidiao: { id: 4, name: "未审核(计调)" },
    yishenhe_jidiao: { id: 5, name: "已审核(计调)" },
    weishenhe_caiwu: { id: 6, name: "未审核(财务)" },
    yishenhe_caiwu: { id: 7, name: "已审核(财务)" },
    yibao: { id: 8, name: "已报" },
    getArray: function getArray() {
        return _getArray(this);
    },
    getName: function getName(id) {
        return _getName(this, id);
    }
};

var accountAllotType = exports.accountAllotType = {
    anbili: {
        id: 1, name: "按比例"
    },
    anlirun: {
        id: 2, name: "按利润"
    },
    getArray: function getArray() {
        return _getArray(this);
    },
    getName: function getName(id) {
        return _getName(this, id);
    }
};

/***/ }),
/* 68 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.computedprops = undefined;

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _config = __webpack_require__(67);

var _config2 = _interopRequireDefault(_config);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var obj = {
    getUser: function getUser() {
        var user = JSON.parse(window.sessionStorage.getItem('user'));
        user.duty_id = _config2.default.dutyType.caiwu.id;
        return user;
    },
    getUserId: function getUserId() {
        var user = JSON.parse(window.sessionStorage.getItem('user'));
        return user.uid;
    },

    getUserDutyId: function getUserDutyId() {
        return this.getUser().duty_id;
    },
    setUser: function setUser(user) {
        window.sessionStorage.setItem('user', (0, _stringify2.default)(user));
    }
};
var computedprops = {
    isDaoyou: function isDaoyou() {
        return obj.getUserDutyId() == _config2.default.dutyType.daoyou.id;
    },
    isJiDiao: function isJiDiao() {
        return obj.getUserDutyId() == _config2.default.dutyType.jidiao.id;
    },
    isCaiwu: function isCaiwu() {
        return obj.getUserDutyId() == _config2.default.dutyType.caiwu.id;
    },
    isJingli: function isJingli() {
        return obj.getUserDutyId() == _config2.default.dutyType.jingli.id;
    }
};
exports.computedprops = computedprops;
exports.default = obj;

/***/ }),
/* 69 */,
/* 70 */,
/* 71 */,
/* 72 */,
/* 73 */,
/* 74 */,
/* 75 */,
/* 76 */,
/* 77 */,
/* 78 */,
/* 79 */,
/* 80 */,
/* 81 */,
/* 82 */,
/* 83 */,
/* 84 */,
/* 85 */,
/* 86 */,
/* 87 */,
/* 88 */,
/* 89 */,
/* 90 */,
/* 91 */,
/* 92 */,
/* 93 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(226)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(129),
  /* template */
  __webpack_require__(257),
  /* scopeId */
  "data-v-bbef9fca",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 94 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(222)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(130),
  /* template */
  __webpack_require__(253),
  /* scopeId */
  "data-v-38fbedd4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 95 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _mock = __webpack_require__(148);

var _mock2 = _interopRequireDefault(_mock);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = _mock2.default;

/***/ }),
/* 96 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _toConsumableArray2 = __webpack_require__(73);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _vuex = __webpack_require__(58);

var _vuex2 = _interopRequireDefault(_vuex);

var _api = __webpack_require__(17);

var _config = __webpack_require__(67);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_vue2.default.use(_vuex2.default);

var state = {
    companies: [],
    parties: [],
    duties: [],
    guides: [],
    locations: [],
    hotels: [],
    drivers: [],
    accountConfig: {}
};

var mutations = {
    setCompanies: function setCompanies(state, data) {
        var _state$companies;

        state.companies.length = 0;
        (_state$companies = state.companies).push.apply(_state$companies, (0, _toConsumableArray3.default)(data));
    },
    setParties: function setParties(state, data) {
        var _state$parties;

        state.parties.length = 0;
        (_state$parties = state.parties).push.apply(_state$parties, (0, _toConsumableArray3.default)(data));
    },
    setDuties: function setDuties(state, data) {
        var _state$duties;

        state.duties.length = 0;
        (_state$duties = state.duties).push.apply(_state$duties, (0, _toConsumableArray3.default)(data));
    },
    setGuides: function setGuides(state, data) {
        var _state$guides;

        state.guides.length = 0;
        (_state$guides = state.guides).push.apply(_state$guides, (0, _toConsumableArray3.default)(data));
    },
    setLocations: function setLocations(state, data) {
        var _state$locations;

        state.locations.length = 0;
        (_state$locations = state.locations).push.apply(_state$locations, (0, _toConsumableArray3.default)(data));
    },
    setHotels: function setHotels(state, data) {
        var _state$hotels;

        state.hotels.length = 0;
        (_state$hotels = state.hotels).push.apply(_state$hotels, (0, _toConsumableArray3.default)(data));
    },
    setDrivers: function setDrivers(state, data) {
        var _state$drivers;

        state.drivers.length = 0;
        (_state$drivers = state.drivers).push.apply(_state$drivers, (0, _toConsumableArray3.default)(data));
    },
    setAccountConfig: function setAccountConfig(state, data) {
        state.accountConfig = {};
        data.allot_type = _config.accountAllotType.getArray();
        data.account_status = _config.accountStatus;
        state.accountConfig = data;
    }
};

var actions = {
    refreshCompanies: function refreshCompanies(context) {
        (0, _api.getCompanyList)().then(function (resp) {
            console.log('getCompanyList');
            context.commit("setCompanies", resp.data.data);
        });
    },
    refreshParties: function refreshParties(context) {
        (0, _api.getDepartmentList)().then(function (resp) {
            console.log('refreshParties');
            context.commit("setParties", resp.data.data);
        });
    },
    refreshDuties: function refreshDuties(context) {
        (0, _api.getJobList)().then(function (resp) {
            context.commit("setDuties", resp.data.data);
        });
    },
    refreshGuides: function refreshGuides(context) {
        (0, _api.getGuides)().then(function (resp) {
            context.commit("setGuides", resp.data.data.data);
        });
    },
    refreshLocations: function refreshLocations(context) {
        (0, _api.getLocations)().then(function (resp) {
            context.commit("setLocations", resp.data.data.data);
        });
    },
    refreshHotels: function refreshHotels(context) {
        (0, _api.getProdDataListPage)('hotel', {}).then(function (resp) {
            context.commit("setHotels", resp.data.data.data);
        });
    },
    refreshDrivers: function refreshDrivers(context) {
        (0, _api.getProdDataListPage)('driver', {}).then(function (resp) {
            context.commit("setDrivers", resp.data.data.data);
        });
    },
    refreshAccountConfig: function refreshAccountConfig(context) {
        if (context.state.accountConfig != undefined && (0, _keys2.default)(context.state.accountConfig).length > 0) {
            return;
        }
        (0, _api.getAccountConfig)().then(function (resp) {
            context.commit('setAccountConfig', resp.data.data.data);
        });
    },
    refreshBaseInfo: function refreshBaseInfo(context) {
        context.dispatch("refreshCompanies");
        context.dispatch("refreshParties");
        context.dispatch("refreshDuties");
    }
};

exports.default = new _vuex2.default.Store({
    state: state,
    mutations: mutations,
    actions: actions
});

/***/ }),
/* 97 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 98 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 99 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(219)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(121),
  /* template */
  __webpack_require__(250),
  /* scopeId */
  null,
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 100 */,
/* 101 */,
/* 102 */,
/* 103 */,
/* 104 */,
/* 105 */,
/* 106 */,
/* 107 */,
/* 108 */,
/* 109 */,
/* 110 */,
/* 111 */,
/* 112 */,
/* 113 */,
/* 114 */,
/* 115 */,
/* 116 */,
/* 117 */,
/* 118 */,
/* 119 */,
/* 120 */,
/* 121 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    name: 'app',
    components: {}
};

/***/ }),
/* 122 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {
            sysName: '后台系统',
            collapsed: false,
            sysUserName: '',
            sysUserAvatar: '',
            form: {
                name: '',
                region: '',
                date1: '',
                date2: '',
                delivery: false,
                type: [],
                resource: '',
                desc: ''
            }
        };
    },

    methods: {
        onSubmit: function onSubmit() {
            console.log('submit!');
        },
        handleopen: function handleopen() {},
        handleclose: function handleclose() {},

        handleselect: function handleselect(a, b) {},

        logout: function logout() {
            var _this = this;
            this.$confirm('确认退出吗?', '提示', {}).then(function () {
                sessionStorage.removeItem('user');
                _this.$router.push('/login');
            }).catch(function () {});
        },

        collapse: function collapse() {
            this.collapsed = !this.collapsed;
        },
        showMenu: function showMenu(i, status) {
            this.$refs.menuCollapsed.getElementsByClassName('submenu-hook-' + i)[0].style.display = status ? 'block' : 'none';
        }
    },
    mounted: function mounted() {
        var user = sessionStorage.getItem('user');
        if (user) {
            user = JSON.parse(user);
            this.sysUserName = user.name || '';
            this.sysUserAvatar = user.avatar || '';
        }
    },

    computed: {
        key: function key() {
            return this.$route.path;
        }
    }
};

/***/ }),
/* 123 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
  value: true
});

var _api = __webpack_require__(17);

var _userutils = __webpack_require__(68);

var _userutils2 = _interopRequireDefault(_userutils);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
  data: function data() {
    return {
      logining: false,
      ruleForm2: {
        account: '',
        pwd: ''
      },
      rules2: {
        account: [{ required: true, message: '请输入账号', trigger: 'blur' }],
        pwd: [{ required: true, message: '请输入密码', trigger: 'blur' }]
      },
      checked: true
    };
  },

  methods: {
    handleReset2: function handleReset2() {
      this.$refs.ruleForm2.resetFields();
    },
    handleSubmit2: function handleSubmit2(ev) {
      var _this2 = this;

      var _this = this;
      this.$refs.ruleForm2.validate(function (valid) {
        if (valid) {
          _this2.logining = true;

          var loginParams = { userName: _this2.ruleForm2.account, password: _this2.ruleForm2.pwd };
          (0, _api.requestLogin)(loginParams).then(function (resp) {
            _this2.logining = false;

            console.log(resp);
            var _resp$data = resp.data,
                msg = _resp$data.msg,
                code = _resp$data.code,
                data = _resp$data.data;

            if (code !== 0) {
              _this2.$message({
                message: msg,
                type: 'error'
              });
            } else {
              _userutils2.default.setUser(data);
              _this2.$router.push({ path: '/' });
            }
          });
        } else {
          console.log('error submit!!');
          return false;
        }
      });
    }
  }
};

/***/ }),
/* 124 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _defineProperty2 = __webpack_require__(157);

var _defineProperty3 = _interopRequireDefault(_defineProperty2);

var _NumberCard = __webpack_require__(244);

var _NumberCard2 = _interopRequireDefault(_NumberCard);

var _ValueCard = __webpack_require__(93);

var _ValueCard2 = _interopRequireDefault(_ValueCard);

var _HomeBody = __webpack_require__(247);

var _HomeBody2 = _interopRequireDefault(_HomeBody);

var _SingleChart = __webpack_require__(246);

var _SingleChart2 = _interopRequireDefault(_SingleChart);

var _ValueCardGroup = __webpack_require__(94);

var _ValueCardGroup2 = _interopRequireDefault(_ValueCardGroup);

var _api = __webpack_require__(17);

var _team_assign = __webpack_require__(66);

var _team_assign2 = _interopRequireDefault(_team_assign);

var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var echarts = function echarts() {
    return __webpack_require__.e/* import() */(0).then(__webpack_require__.bind(null, 101));
};
exports.default = {
    data: function data() {
        var init_charts = [];
        for (var i = 0; i < 1; i++) {
            init_charts.push({
                type: 'line',
                title: "",
                x_name: "",
                y_name: "",
                y_data: [],
                x_data: [],
                more_info: [{
                    key: "",
                    value: "",
                    scheme: ""
                }]
            });
        }

        return {
            base_data: [],
            slide_data: [],
            charts: init_charts,
            tables: [],
            chartLine: null,
            chart_loading: true,
            limite_data: [2017, 2016],
            selected_year: 2017
        };
    },

    components: { NumberCard: _NumberCard2.default, HomeBody: _HomeBody2.default, ValueCard: _ValueCard2.default, SingleChart: _SingleChart2.default, ValueCardGroup: _ValueCardGroup2.default },
    methods: (0, _defineProperty3.default)({
        getData: function getData(dataitem) {
            console.log("select" + dataitem);
        },

        getChartData: function getChartData() {
            var _this = this;

            this.chart_loading = true;
            (0, _api.getCharts)().then(function (res) {
                var chartdata = res.data.data.data;
                for (var i = 0; i < chartdata.length; i++) {
                    _vue2.default.set(_this.charts, i, chartdata[i]);
                }
                _this.chart_loading = false;
            });
        }
    }, 'getData', function getData() {
        var _this2 = this;

        (0, _api.getMainpageCards)().then(function (res) {
            _this2.base_data = res.data.data.base_data;
            _this2.slide_data = res.data.data.slide_data;
        });

        (0, _api.getHomeTables)().then(function (res) {
            _this2.tables = res.data.data.tables;
        });
    }),
    computed: {
        teamassigns: function teamassigns() {
            return _team_assign2.default;
        }
    },
    mounted: function mounted() {
        this.getData();
        this.getChartData();
    }
};

/***/ }),
/* 125 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _assign = __webpack_require__(36);

var _assign2 = _interopRequireDefault(_assign);

var _util = __webpack_require__(133);

var _util2 = _interopRequireDefault(_util);

var _api = __webpack_require__(17);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {
            filters: {
                name: ""
            },
            departmentDatas: [],
            users: [],
            departments: [],
            jobRules: [],
            companies: [],
            total: 0,
            page: 1,
            listLoading: false,
            treeDepartment: "",
            sels: [],
            editFormVisible: false,
            editLoading: false,
            editFormRules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
            },

            editForm: {
                id: 0,
                name: "",
                nickname: "",
                gender: "male",
                mobile: "",
                identify_no: "",
                birthday: ""
            },

            addFormVisible: false,
            addLoading: false,
            addFormRules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }]
            },

            addForm: {
                name: "",
                nickname: "",
                gender: "male",
                mobile: "",
                identify_no: ""
            },
            departmentProps: {
                value: "id",
                label: "label"
            },
            rules: {
                name: [{ required: true, message: "请输入姓名", trigger: "blur" }],
                nickname: [{ required: true, message: "请输入用户名", trigger: "blur" }],
                password: [{ required: true, message: "请输入密码", trigger: "blur" }],
                phone: [{ required: true, message: "请输入电话", trigger: "blur" }, { pattern: /^1\d{10}$/, message: "请输入正确的电话", trigger: "blur" }],
                address: [{ required: true, message: "请输入地址", trigger: "blur" }],
                id_card_num: [{ required: true, message: "请输入身份证", trigger: "blur" }, { pattern: /(^\d{15}$)|(^\d{18}$)|(^\d{17}(\d|X|x)$)/, message: "请输入正确的身份证", trigger: "blur" }],

                department_id: [{
                    validator: function validator(rule, value, callback, source, options) {
                        var errors = [];
                        console.log(value);
                        console.log(source);
                        if (source.department_id.length === 0) {
                            errors.push(new Error("请选择部门"));
                        }
                        console.log(errors);
                        callback(errors);
                    }
                }]
            }

        };
    },

    methods: {
        goDetail: function goDetail(index, row) {
            this.$router.push('/user/health/' + row.uid);
        },

        formatSex: function formatSex(row, column) {
            return row.sex == 1 ? "男" : row.sex == 0 ? "女" : "未知";
        },
        handleCurrentChange: function handleCurrentChange(val) {
            this.page = val;
            this.getUsers();
        },
        getUsers: function getUsers(treeDepartmentId) {
            var _this = this;

            if (treeDepartmentId === 0 || !treeDepartmentId) {
                treeDepartmentId = "";
            }
            console.log(treeDepartmentId);
            var para = {
                page: this.page,
                name: this.filters.name,
                department: treeDepartmentId
            };
            this.listLoading = true;
            (0, _api.requestUserList)(this, para).then(function (data) {
                _this.total = data.length;
                _this.users = data;
                _this.listLoading = false;
            });
        },
        getDepartments: function getDepartments() {
            var _this2 = this;

            (0, _api.getDepartmentList)().then(function (res) {
                _this2.departments = res.data.data.list.map(function (ele) {
                    ele.value = ele.id;
                    return ele;
                });
            });
        },
        getJobRules: function getJobRules() {
            var _this3 = this;

            (0, _api.getDataListPage)("rule").then(function (res) {
                _this3.jobRules = res.data.data.list;
                console.log("rules", _this3.jobRules);
            });
        },
        getCompanies: function getCompanies() {
            var _this4 = this;

            (0, _api.getCompanyList)().then(function (res) {
                _this4.companies = res.data.data;
            });
        },

        handleDel: function handleDel(index, row) {
            var _this5 = this;

            this.$confirm("确认删除该记录吗?", "提示", {
                type: "warning"
            }).then(function () {
                _this5.listLoading = true;

                var para = { id: row.id };
                (0, _api.removeUser)(para).then(function (res) {
                    _this5.listLoading = false;

                    _this5.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    _this5.getUsers();
                });
            }).catch(function () {});
        },
        getDepartment: function getDepartment() {
            var _this6 = this;

            var para = {
                page: this.page,
                name: ""
            };
            this.listLoading = true;
            (0, _api.getDataListPage)("department", para).then(function (res) {
                var databody = res.data.data;
                _this6.departmentDatas = databody.list;
            });
        },

        handleEdit: function handleEdit(index, row) {
            this.editFormVisible = true;
            console.log("row", row);
            var result = [];
            this.getTreeArrayById(row.department_id, this.departments, result);
            this.editForm = (0, _assign2.default)({}, row, { department_id: result });
            console.log(this.editForm);
        },

        handleAdd: function handleAdd() {
            this.addFormVisible = true;
            this.addForm = {
                name: "",
                sex: -1,
                address: "",
                phone: "",
                id_card_num: "",
                guide_card_num: "",
                department_id: [],
                rule_id: "",
                company_id: ""
            };
        },

        editSubmit: function editSubmit() {
            var _this7 = this;

            this.$refs.editForm.validate(function (valid) {
                if (valid) {
                    _this7.$confirm("确认提交吗？", "提示", {}).then(function () {
                        _this7.editLoading = true;

                        var departments = _this7.editForm.department_id;
                        var para = (0, _assign2.default)({}, _this7.editForm, { department_id: departments[departments.length - 1] });
                        (0, _api.editData)("user", para).then(function (res) {
                            _this7.editLoading = false;
                            _this7.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            _this7.$refs["editForm"].resetFields();
                            _this7.editFormVisible = false;
                            _this7.getUsers();
                        });
                    });
                }
            });
        },

        addSubmit: function addSubmit() {
            var _this8 = this;

            this.$refs.addForm.validate(function (valid) {
                if (valid) {
                    _this8.$confirm("确认提交吗？", "提示", {}).then(function () {
                        _this8.addLoading = true;

                        var para = (0, _assign2.default)({}, _this8.addForm);
                        para.department_id = para.department_id[0];
                        console.log(para);
                        (0, _api.addProdData)("user", para).then(function (res) {
                            _this8.addLoading = false;

                            _this8.$message({
                                message: "提交成功",
                                type: "success"
                            });
                            _this8.$refs["addForm"].resetFields();
                            _this8.addFormVisible = false;
                            _this8.getUsers();
                        });
                    });
                }
            });
        },
        selsChange: function selsChange(sels) {
            this.sels = sels;
        },
        getTreeArrayById: function getTreeArrayById(id, tree, result) {
            if (id >= 0) {
                var source = this.findTreeNode(id, this.departments);
                console.log("did", id, source);
                if (source) {
                    result.unshift(id);
                    this.getTreeArrayById(source.parent_id, tree, result);
                }
            }
        },
        findTreeNode: function findTreeNode(id, tree) {
            if (tree) {
                for (var index = 0; index < tree.length; index++) {
                    var current = tree[index];
                    if (current && current.id === id) {
                        return tree[index];
                    } else {
                        if (current.children && current.children.length > 0) {
                            return this.findTreeNode(id, current.children);
                        }
                    }
                }
            }
            return undefined;
        },

        batchRemove: function batchRemove() {
            var _this9 = this;

            var ids = this.sels.map(function (item) {
                return item.id;
            }).toString();
            this.$confirm("确认删除选中记录吗？", "提示", {
                type: "warning"
            }).then(function () {
                _this9.listLoading = true;

                var para = { ids: ids };
                (0, _api.batchRemoveUser)(para).then(function (res) {
                    _this9.listLoading = false;

                    _this9.$message({
                        message: "删除成功",
                        type: "success"
                    });
                    _this9.getUsers();
                });
            }).catch(function () {});
        }
    },
    mounted: function mounted() {
        this.getUsers();
    }
};

/***/ }),
/* 126 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    },

    props: {
        cardname: '',
        cardvalue: ''
    }
};

/***/ }),
/* 127 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    },
    props: {
        config: Object,
        srcdata: Array,
        title: String
    },
    computed: {
        fieldmap: function fieldmap() {
            return this.config.fieldmap;
        }
    },
    methods: {
        row_click: function row_click(row) {
            this.$router.push(row.scheme);
        }
    },
    mounted: function mounted() {}
};

/***/ }),
/* 128 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ValueCardGroup = __webpack_require__(94);

var _ValueCardGroup2 = _interopRequireDefault(_ValueCardGroup);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var echarts = function echarts() {
    return __webpack_require__.e/* import() */(0/* duplicate */).then(__webpack_require__.bind(null, 101));
};
exports.default = {
    data: function data() {
        var randomid = "s" + Math.random();
        return {
            random_id: randomid,
            chartColumn: null
        };
    },

    components: { ValueCardGroup: _ValueCardGroup2.default },
    props: {
        title: {
            default: function _default() {
                return "";
            }
        },
        chart_type: {
            default: function _default() {
                return "line";
            }
        },
        x_name: {
            default: function _default() {
                return "";
            }
        },
        y_name: {
            default: function _default() {
                return "";
            }
        },
        x_data: {
            default: function _default() {
                return [];
            }
        },
        x_axis: {
            default: function _default() {
                return [];
            }
        },
        is_loading: {
            default: function _default() {
                return true;
            }
        },
        more_info: {
            default: function _default() {
                return [];
            }
        }
    },
    methods: {
        drawColumnChart: function drawColumnChart() {
            this.chartColumn = echarts.init(document.getElementById(this.random_id));
            console.log("type:" + this.chart_type);
            console.log("title:" + this.title);

            this.chartColumn.setOption({
                title: { text: this.title },
                tooltip: {},
                xAxis: {
                    data: this.x_axis
                },
                yAxis: {},
                series: [{
                    name: this.title,
                    type: this.chart_type,
                    data: this.x_data
                }]
            });
        },
        drawCharts: function drawCharts() {
            this.drawColumnChart();
        }
    },

    mounted: function mounted() {
        this.drawCharts();
    },
    watch: {
        title: function title() {
            if (this.chartColumn) {
                this.drawCharts();
            }
        },
        is_loading: function is_loading() {
            console.log("isloading0");
            if (this.chartColumn) {
                console.log("isloading1" + this.is_loading);
                if (this.is_loading) {
                    this.chartColumn.showLoading();
                } else {
                    this.chartColumn.hideLoading();
                }
            }
        }
    },
    updated: function updated() {}
};

/***/ }),
/* 129 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    data: function data() {
        return {};
    },

    props: {
        cardname: '',
        cardvalue: '',
        linkto: ''
    },
    methods: {
        go: function go() {
            this.$router.push(this.linkto);
        },
        addMaohao: function addMaohao(value) {
            if (value && ("" + value).length > 0) {
                return ":" + value;
            } else {
                return "";
            }
        }
    },
    computed: {}
};

/***/ }),
/* 130 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _ValueCard = __webpack_require__(93);

var _ValueCard2 = _interopRequireDefault(_ValueCard);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    data: function data() {
        return {};
    },
    components: { ValueCard: _ValueCard2.default },
    props: {
        data: {
            default: function _default() {
                return {
                    data: []
                };
            }
        }
    },
    methods: {},
    computed: {
        card_data: function card_data() {
            return this.data;
        },
        card_col_size: function card_col_size() {
            return 24 / this.data.length;
        }
    }
};

/***/ }),
/* 131 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _values = __webpack_require__(72);

var _values2 = _interopRequireDefault(_values);

var _keys = __webpack_require__(71);

var _keys2 = _interopRequireDefault(_keys);

var _col = __webpack_require__(217);

var _col2 = _interopRequireDefault(_col);

var _SimpleTable = __webpack_require__(245);

var _SimpleTable2 = _interopRequireDefault(_SimpleTable);

var _api = __webpack_require__(17);

var _team_assign = __webpack_require__(66);

var _team_assign2 = _interopRequireDefault(_team_assign);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

exports.default = {
    components: { ElCol: _col2.default, SimpleTable: _SimpleTable2.default },
    data: function data() {
        return {};
    },
    props: {
        table_list: {
            default: function _default() {
                return [];
            }
        }
    },
    methods: {},
    mounted: function mounted() {},
    computed: {
        table_data_list: function table_data_list() {
            for (var key in this.table_list) {
                var current_item = this.table_list[key];
                current_item.config = {
                    fieldmap: [{
                        key: (0, _keys2.default)(current_item.colname)[0],
                        name: (0, _values2.default)(current_item.colname)[0],
                        width: 100
                    }, {
                        key: (0, _keys2.default)(current_item.colname)[1],
                        name: (0, _values2.default)(current_item.colname)[1],
                        width: 200
                    }]
                };
            }

            return this.table_list;
        }

    }
};

/***/ }),
/* 132 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.default = {
    components: {},
    data: function data() {
        return {
            fileList: []
        };
    },
    props: {},
    methods: {
        goDownload: function goDownload(fileName) {
            window.open('api/download?file_name=' + fileName);
        },
        onUploadSuccess: function onUploadSuccess(resp, file) {
            this.fileList = this.fileList.concat(resp.data.file_list);
        }
    },
    mounted: function mounted() {}
};

/***/ }),
/* 133 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
var SIGN_REGEXP = /([yMdhsm])(\1*)/g;
var DEFAULT_PATTERN = 'yyyy-MM-dd';
function padding(s, len) {
    var len = len - (s + '').length;
    for (var i = 0; i < len; i++) {
        s = '0' + s;
    }
    return s;
};

exports.default = {
    getQueryStringByName: function getQueryStringByName(name) {
        var reg = new RegExp("(^|&)" + name + "=([^&]*)(&|$)", "i");
        var r = window.location.search.substr(1).match(reg);
        var context = "";
        if (r != null) context = r[2];
        reg = null;
        r = null;
        return context == null || context == "" || context == "undefined" ? "" : context;
    },
    formatDate: {

        format: function format(date, pattern) {
            pattern = pattern || DEFAULT_PATTERN;
            return pattern.replace(SIGN_REGEXP, function ($0) {
                switch ($0.charAt(0)) {
                    case 'y':
                        return padding(date.getFullYear(), $0.length);
                    case 'M':
                        return padding(date.getMonth() + 1, $0.length);
                    case 'd':
                        return padding(date.getDate(), $0.length);
                    case 'w':
                        return date.getDay() + 1;
                    case 'h':
                        return padding(date.getHours(), $0.length);
                    case 'm':
                        return padding(date.getMinutes(), $0.length);
                    case 's':
                        return padding(date.getSeconds(), $0.length);
                }
            });
        },
        parse: function parse(dateString, pattern) {
            var matchs1 = pattern.match(SIGN_REGEXP);
            var matchs2 = dateString.match(/(\d)+/g);
            if (matchs1.length == matchs2.length) {
                var _date = new Date(1970, 0, 1);
                for (var i = 0; i < matchs1.length; i++) {
                    var _int = parseInt(matchs2[i]);
                    var sign = matchs1[i];
                    switch (sign.charAt(0)) {
                        case 'y':
                            _date.setFullYear(_int);break;
                        case 'M':
                            _date.setMonth(_int - 1);break;
                        case 'd':
                            _date.setDate(_int);break;
                        case 'h':
                            _date.setHours(_int);break;
                        case 'm':
                            _date.setMinutes(_int);break;
                        case 's':
                            _date.setSeconds(_int);break;
                    }
                }
                return _date;
            }
            return null;
        }

    }

};

/***/ }),
/* 134 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});


var config = {
    entityname: 'team',
    fieldmap: [{
        key: "title",
        name: "标题",
        width: 200
    }, {
        key: "team_id",
        name: "团号",
        width: 100
    }, {
        key: "people_count",
        name: "人数",
        width: 100
    }, {
        key: "location_name",
        name: "地区",
        width: 200
    }, {
        key: "date_on",
        name: "团期",
        width: 200
    }, {
        key: "status_name",
        name: "状态",
        width: 150,
        type: "checkbox"
    }],
    rules: {},
    showopt: true
};

exports.default = config;

/***/ }),
/* 135 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


var _vue = __webpack_require__(33);

var _vue2 = _interopRequireDefault(_vue);

var _App = __webpack_require__(99);

var _App2 = _interopRequireDefault(_App);

var _elementUi = __webpack_require__(59);

var _elementUi2 = _interopRequireDefault(_elementUi);

__webpack_require__(97);

var _vueRouter = __webpack_require__(100);

var _vueRouter2 = _interopRequireDefault(_vueRouter);

var _store = __webpack_require__(96);

var _store2 = _interopRequireDefault(_store);

var _vuex = __webpack_require__(58);

var _vuex2 = _interopRequireDefault(_vuex);

var _routes = __webpack_require__(57);

var _routes2 = _interopRequireDefault(_routes);

var _http = __webpack_require__(32);

var _http2 = _interopRequireDefault(_http);

var _mock = __webpack_require__(95);

var _mock2 = _interopRequireDefault(_mock);

__webpack_require__(98);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

_mock2.default.bootstrap(_http2.default);

_vue2.default.prototype.$http = _http2.default;

_vue2.default.use(_elementUi2.default);
_vue2.default.use(_vueRouter2.default);
_vue2.default.use(_vuex2.default);
var createCookie = function createCookie(name, value, days) {
    var expires;
    if (days) {
        var date = new Date();
        date.setTime(date.getTime() + days * 24 * 60 * 60 * 1000);
        expires = "; expires=" + date.toGMTString();
    } else {
        expires = "";
    }
    document.cookie = name + "=" + value + expires + "; path=/";
};
createCookie("user", "1", 30);
createCookie("platform", "web", 30);

var router = new _vueRouter2.default({
    routes: _routes2.default
});

router.beforeEach(function (to, from, next) {
    if (to.path == '/login') {
        sessionStorage.removeItem('user');
    }
    var user = JSON.parse(sessionStorage.getItem('user'));
    if (!user && to.path != '/login') {
        next({ path: '/login' });
    } else {
        next();
    }
});

new _vue2.default({
    router: router,
    store: _store2.default,
    render: function render(h) {
        return h(_App2.default);
    }
}).$mount('#app');

/***/ }),
/* 136 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var CarTeams = [];
for (var i = 0; i < 5; i++) {
    CarTeams.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '车队' + _mockjs2.default.Random.cname(),
        driver_name: _mockjs2.default.Random.cname(),
        bus_size: _mockjs2.default.Random.integer(10, 50) + '',
        driver_phone: _mockjs2.default.Random.integer(18911410800, 18911410899) + ''
    }));
}

exports.default = CarTeams;

/***/ }),
/* 137 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Companies = [];
for (var i = 0; i < 10; i++) {
    Companies.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '公司' + _mockjs2.default.Random.province()
    }));
}

exports.default = Companies;

/***/ }),
/* 138 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Duties = [];
for (var i = 0; i < 5; i++) {
    Duties.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '职务' + _mockjs2.default.Random.province()
    }));
}

exports.default = Duties;

/***/ }),
/* 139 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Hotels = [];
for (var i = 0; i < 5; i++) {
    Hotels.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '酒店' + _mockjs2.default.Random.province(),
        phone: _mockjs2.default.Random.integer(18911410000, 18911419999) + '',
        address: _mockjs2.default.mock('@county(true)')
    }));
}

exports.default = Hotels;

/***/ }),
/* 140 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var MainPageCards = [];
for (var i = 0; i < 6; i++) {
    MainPageCards.push(_mockjs2.default.mock({
        name: '名字' + _mockjs2.default.Random.cname(),
        value: _mockjs2.default.Random.integer(1000, 9999)
    }));
}

exports.default = MainPageCards;

/***/ }),
/* 141 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Parties = [];
for (var i = 0; i < 5; i++) {
    Parties.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '部门' + _mockjs2.default.Random.province()
    }));
}

exports.default = Parties;

/***/ }),
/* 142 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Restaurant = [];
for (var i = 0; i < 5; i++) {
    Restaurant.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '餐厅' + _mockjs2.default.Random.province(),
        phone: _mockjs2.default.Random.integer(18911410000, 18911419999) + '',
        mark: _mockjs2.default.mock('@county(true)')
    }));
}

exports.default = Restaurant;

/***/ }),
/* 143 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.getNewMock = undefined;

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var Teams = [];

function refresh(data) {
    data.length = 0;
    for (var i = 0; i < 5; i++) {
        data.push(_mockjs2.default.mock({
            id: _mockjs2.default.Random.guid(),
            title: '团-' + _mockjs2.default.Random.province(),
            num: _mockjs2.default.Random.integer(10, 99) + '',
            member_count: _mockjs2.default.Random.integer(10, 99) + '',
            location: _mockjs2.default.Random.province(),
            date: _mockjs2.default.Random.date() + '',
            finished: _mockjs2.default.Random.pick(['是', '否']) + ''
        }));
    }

    return data;
}

refresh(Teams);

function getNewMock() {
    var result = [];
    return refresh(result);
}

exports.getNewMock = getNewMock;
exports.default = Teams;

/***/ }),
/* 144 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamDates = [];
for (var i = 0; i < 5; i++) {
    TeamDates.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        title: '团期-' + _mockjs2.default.Random.province(),
        num: _mockjs2.default.Random.integer(10, 99) + '',
        member_count: _mockjs2.default.Random.integer(10, 99) + '',
        location: _mockjs2.default.Random.province(),
        date: _mockjs2.default.Random.date() + ''
    }));
}

exports.default = TeamDates;

/***/ }),
/* 145 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var TeamMoneys = [];
for (var i = 0; i < 5; i++) {
    TeamMoneys.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        title: '团款-' + _mockjs2.default.Random.province(),
        num: _mockjs2.default.Random.integer(10, 99) + '',
        member_count: _mockjs2.default.Random.integer(10, 99) + '',
        location: _mockjs2.default.Random.province(),
        price: _mockjs2.default.Random.integer(1000, 9999) + '',
        date: _mockjs2.default.Random.date() + '',
        finished: _mockjs2.default.Random.pick(['是', '否']) + '',
        validate_off: _mockjs2.default.Random.pick(['是', '否']) + '',
        account_off: _mockjs2.default.Random.pick(['是', '否']) + ''
    }));
}

exports.default = TeamMoneys;

/***/ }),
/* 146 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.Companies = exports.Duties = exports.Parties = exports.Users = exports.LoginUsers = undefined;

var _assign = __webpack_require__(36);

var _assign2 = _interopRequireDefault(_assign);

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

var _duty = __webpack_require__(138);

var _duty2 = _interopRequireDefault(_duty);

var _company = __webpack_require__(137);

var _company2 = _interopRequireDefault(_company);

var _party = __webpack_require__(141);

var _party2 = _interopRequireDefault(_party);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var LoginUsers = [];

var Users = [];

for (var i = 0; i < 10; i++) {
    Users.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: _mockjs2.default.Random.cname(),
        sex: _mockjs2.default.Random.integer(0, 1),
        phone: _mockjs2.default.Random.integer(18911410000, 18911419999) + '',
        address: _mockjs2.default.mock('@county(true)'),
        id_card_num: "" + _mockjs2.default.Random.integer(130183198600000000, 130183198699999999),
        guide_card_num: "D-" + _mockjs2.default.Random.integer(1000, 9999) + '-' + _mockjs2.default.Random.integer(100000, 999999),
        party_id: _mockjs2.default.Random.pick(_party2.default).id,
        duties_id: _mockjs2.default.Random.pick(_duty2.default).id,
        company_id: _mockjs2.default.Random.pick(_company2.default).id
    }));
}

Users[0] = (0, _assign2.default)(Users[0], {
    username: 'admin',
    password: '123456',
    avatar: 'https://raw.githubusercontent.com/taylorchen709/markdown-images/master/vueadmin/user.png'
});

LoginUsers.push(Users[0]);

exports.LoginUsers = LoginUsers;
exports.Users = Users;
exports.Parties = _party2.default;
exports.Duties = _duty2.default;
exports.Companies = _company2.default;

/***/ }),
/* 147 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var ViewSpot = [];
for (var i = 0; i < 5; i++) {
    ViewSpot.push(_mockjs2.default.mock({
        id: _mockjs2.default.Random.guid(),
        name: '景点名称' + _mockjs2.default.Random.province(),
        phone: _mockjs2.default.Random.integer(18911410000, 18911419999) + '',
        mark: "备注" + _mockjs2.default.mock('@county(true)')
    }));
}

exports.default = ViewSpot;

/***/ }),
/* 148 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _stringify = __webpack_require__(70);

var _stringify2 = _interopRequireDefault(_stringify);

var _toConsumableArray2 = __webpack_require__(73);

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _http = __webpack_require__(32);

var _http2 = _interopRequireDefault(_http);

var _axiosMockAdapter = __webpack_require__(60);

var _axiosMockAdapter2 = _interopRequireDefault(_axiosMockAdapter);

var _user = __webpack_require__(146);

var _hotel = __webpack_require__(139);

var _hotel2 = _interopRequireDefault(_hotel);

var _carteam = __webpack_require__(136);

var _carteam2 = _interopRequireDefault(_carteam);

var _restaurant = __webpack_require__(142);

var _restaurant2 = _interopRequireDefault(_restaurant);

var _viewspot = __webpack_require__(147);

var _viewspot2 = _interopRequireDefault(_viewspot);

var _mainpage_cards = __webpack_require__(140);

var _mainpage_cards2 = _interopRequireDefault(_mainpage_cards);

var _team = __webpack_require__(143);

var _team2 = _interopRequireDefault(_team);

var _teammoney = __webpack_require__(145);

var _teammoney2 = _interopRequireDefault(_teammoney);

var _teamdate = __webpack_require__(144);

var _teamdate2 = _interopRequireDefault(_teamdate);

var _home = __webpack_require__(151);

var _home2 = _interopRequireDefault(_home);

var _charts = __webpack_require__(150);

var _charts2 = _interopRequireDefault(_charts);

var _mockutils = __webpack_require__(149);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function getData(key, datas) {
    var temp_data = JSON.parse(sessionStorage.getItem(key));
    var result_data = [];
    if (!temp_data) {
        result_data.push.apply(result_data, (0, _toConsumableArray3.default)(datas));
        sessionStorage.setItem(key, (0, _stringify2.default)(result_data));
    } else {
        result_data.push.apply(result_data, (0, _toConsumableArray3.default)(temp_data));
    }
    return result_data;
}

var _Users = getData("user_mock_data", _user.Users);
var _Parties = getData("party_mock_data", _user.Parties);
var _Duties = getData("duty_mock_data", _user.Duties);
var _Companies = getData("company_mock_data", _user.Companies);

exports.default = {
    bootstrap: function bootstrap() {
        console.log(_http2.default);
        var mock = new _axiosMockAdapter2.default(_http2.default);

        mock.onGet('/success').reply(200, {
            msg: 'success'
        });

        mock.onGet('/error').reply(500, {
            msg: 'failure'
        });

        mock.onPost('/login').reply(function (config) {
            var _JSON$parse = JSON.parse(config.data),
                username = _JSON$parse.username,
                password = _JSON$parse.password;

            return new _promise2.default(function (resolve, reject) {
                var user = null;
                setTimeout(function () {
                    var hasUser = _user.LoginUsers.some(function (u) {
                        if (u.username === username && u.password === password) {
                            user = JSON.parse((0, _stringify2.default)(u));
                            user.password = undefined;
                            return true;
                        }
                    });

                    if (hasUser) {
                        resolve([200, { code: 0, msg: '请求成功', user: user }]);
                    } else {
                        resolve([200, { code: 430, msg: '账号或密码错误' }]);
                    }
                }, 1000);
            });
        });

        mock.onGet('/user/list').reply(function (config) {
            var name = config.params.name;

            var mockUsers = _Users.filter(function (user) {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        mock.onGet('/user/listpage').reply(function (config) {
            var _config$params = config.params,
                page = _config$params.page,
                name = _config$params.name;

            var mockUsers = _Users.filter(function (user) {
                if (name && user.name.indexOf(name) == -1) return false;
                return true;
            });
            var total = mockUsers.length;
            mockUsers = mockUsers.filter(function (u, index) {
                return index < 20 * page && index >= 20 * (page - 1);
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        total: total,
                        users: mockUsers
                    }]);
                }, 1000);
            });
        });

        mock.onGet('/user/remove').reply(function (config) {
            var id = config.params.id;

            _Users = _Users.filter(function (u) {
                return u.id !== id;
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        mock.onGet('/user/batchremove').reply(function (config) {
            var ids = config.params.ids;

            ids = ids.split(',');
            _Users = _Users.filter(function (u) {
                return !ids.includes(u.id);
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '删除成功'
                    }]);
                }, 500);
            });
        });

        mock.onGet('/user/edit').reply(function (config) {
            console.log("get request");
            console.log(config.params);
            var _config$params2 = config.params,
                id = _config$params2.id,
                name = _config$params2.name,
                sex = _config$params2.sex,
                address = _config$params2.address,
                phone = _config$params2.phone,
                id_card_num = _config$params2.id_card_num,
                guide_card_num = _config$params2.guide_card_num,
                party_id = _config$params2.party_id,
                duties_id = _config$params2.duties_id,
                company_id = _config$params2.company_id;

            _Users.some(function (u) {
                if (u.id === id) {
                    u.name = name;
                    u.sex = sex;
                    u.address = address;
                    u.phone = phone;
                    u.id_card_num = id_card_num;
                    u.guide_card_num = guide_card_num;
                    u.party_id = party_id;
                    u.duties_id = duties_id;
                    u.company_id = company_id;
                    return true;
                }
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        mock.onGet('/user/changepassword').reply(function (config) {
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '密码修改成功'
                    }]);
                }, 500);
            });
        });

        mock.onGet('/user/single').reply(function (config) {
            var id = config.params.id;

            var temp_user = undefined;
            _Users.some(function (u) {
                if (u.id === id) {
                    temp_user = u;
                    return true;
                }
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '编辑成功'
                    }]);
                }, 500);
            });
        });

        mock.onGet('/user/add').reply(function (config) {
            var _config$params3 = config.params,
                name = _config$params3.name,
                sex = _config$params3.sex,
                address = _config$params3.address,
                phone = _config$params3.phone,
                id_card_num = _config$params3.id_card_num,
                guide_card_num = _config$params3.guide_card_num,
                party_id = _config$params3.party_id,
                duties_id = _config$params3.duties_id,
                company_id = _config$params3.company_id;


            _Users.push({
                name: name,
                sex: sex,
                address: address,
                phone: phone,
                id_card_num: id_card_num,
                guide_card_num: guide_card_num,
                party_id: party_id,
                duties_id: duties_id,
                company_id: company_id
            });
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        msg: '新增成功'
                    }]);
                }, 500);
            });
        });

        (0, _mockutils.bindMock)(mock, 'duty', _Duties);
        (0, _mockutils.bindMock)(mock, 'company', _Companies);
        (0, _mockutils.bindMock)(mock, 'party', _Parties);
        (0, _mockutils.bindMock)(mock, 'hotel', _hotel2.default);
        (0, _mockutils.bindMock)(mock, 'carteam', _carteam2.default);
        (0, _mockutils.bindMock)(mock, 'restaurant', _restaurant2.default);
        (0, _mockutils.bindMock)(mock, 'viewspot', _viewspot2.default);
        (0, _mockutils.bindMock)(mock, 'team', _team2.default);
        (0, _mockutils.bindMock)(mock, 'teammoney', _teammoney2.default);
        (0, _mockutils.bindMock)(mock, 'teamdate', _teamdate2.default);

        mock.onGet('/home').reply(function (config) {
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        data: _home2.default
                    }]);
                }, 1000);
            });
        });

        function TeamCommonReply(config, data) {
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        data: data
                    }]);
                }, 1000);
            });
        }
        mock.onGet('/team/assigned').reply(function (config) {
            return TeamCommonReply(config, (0, _team.getNewMock)());
        });
        mock.onGet('/team/unassigned').reply(function (config) {
            return TeamCommonReply(config, (0, _team.getNewMock)());
        });
        mock.onGet('/team/checked').reply(function (config) {
            return TeamCommonReply(config, (0, _team.getNewMock)());
        });
        mock.onGet('/team/unchecked').reply(function (config) {
            return TeamCommonReply(config, (0, _team.getNewMock)());
        });

        mock.onGet('/team/charts').reply(function (config) {
            return new _promise2.default(function (resolve, reject) {
                setTimeout(function () {
                    resolve([200, {
                        code: 0,
                        data: _charts2.default
                    }]);
                }, 500);
            });
        });
    }
};

/***/ }),
/* 149 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});
exports.bindMock = undefined;

var _assign = __webpack_require__(36);

var _assign2 = _interopRequireDefault(_assign);

var _promise = __webpack_require__(27);

var _promise2 = _interopRequireDefault(_promise);

var _ownKeys = __webpack_require__(153);

var _ownKeys2 = _interopRequireDefault(_ownKeys);

var _axiosMockAdapter = __webpack_require__(60);

var _axiosMockAdapter2 = _interopRequireDefault(_axiosMockAdapter);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function bindMock(mock, path, datas) {
    mock.onGet('/' + path + '/add').reply(function (config) {
        console.log("request:" + ('/' + path + '/add'));

        var attr_arr = (0, _ownKeys2.default)(config.params);
        var obj = Object();
        attr_arr.forEach(function (key) {
            return obj[key] = config.params[key];
        });

        datas.push(obj);
        return new _promise2.default(function (resolve, reject) {
            setTimeout(function () {
                resolve([200, {
                    code: 0,
                    msg: '新增成功'
                }]);
            }, 500);
        });
    });

    mock.onGet('/' + path + '/edit').reply(function (config) {
        console.log("request:" + ('/' + path + '/edit'));

        var attr_arr = (0, _ownKeys2.default)(config.params);
        var obj = Object();
        var id = '';
        attr_arr.forEach(function (key) {
            obj[key] = config.params[key];
            if (key == 'id') id = config.params['id'];
        });

        datas.some(function (u) {
            if (u.id === id) {
                (0, _assign2.default)(u, obj);
                return true;
            }
        });
        return new _promise2.default(function (resolve, reject) {
            setTimeout(function () {
                resolve([200, {
                    code: 0,
                    msg: '编辑成功'
                }]);
            }, 500);
        });
    });

    bindListPage(mock, path, datas);
    bindRemove(mock, path, datas);
}

function bindListPage(mock, path, datas) {
    mock.onGet('/' + path + '/listpage').reply(function (config) {
        console.log("request:" + ('/' + path + '/listpage'));

        var name = '';
        if (config.params) {
            name = config.params.name;
        }

        var mock_data = datas.filter(function (data_item) {
            if (name && data_item.name.indexOf(name) == -1) return false;
            return true;
        });

        return new _promise2.default(function (resolve, reject) {
            setTimeout(function () {
                resolve([200, {
                    code: 0,
                    data: mock_data
                }]);
            }, 1000);
        });
    });
}

function bindRemove(mock, path, datas) {
    mock.onGet('/' + path + '/batchremove').reply(function (config) {
        console.log("request:" + ('/' + path + '/batchremove'));

        var ids = config.params.ids;

        ids = ids.split(',');

        ids.forEach(function (u) {
            var itemindex = datas.findIndex(function (ui) {
                return ui.id == u;
            });
            console.log(itemindex);
            if (itemindex > 0) datas.splice(itemindex, 1);
        });

        return new _promise2.default(function (resolve, reject) {
            setTimeout(function () {
                resolve([200, {
                    code: 0,
                    msg: '删除成功'
                }]);
            }, 500);
        });
    });

    mock.onGet('/' + path + '/remove').reply(function (config) {
        console.log("request:" + ('/' + path + '/remove'));

        var id = config.params.id;


        var itemindex = datas.findIndex(function (ui) {
            return ui.id == id;
        });
        console.log(itemindex);
        if (itemindex > 0) datas.splice(itemindex, 1);

        return new _promise2.default(function (resolve, reject) {
            setTimeout(function () {
                resolve([200, {
                    code: 0,
                    msg: '删除成功'
                }]);
            }, 500);
        });
    });
}

exports.bindMock = bindMock;

/***/ }),
/* 150 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var Mock = __webpack_require__(4);

function getRandomData(size) {
    var result = [];
    for (var i = 0; i < size; i++) {
        result.push(Mock.Random.integer(1, 1000));
    }
    return result;
}

function getRandomTitle(size) {
    var result = [];
    for (var i = 0; i < size; i++) {
        result.push(Mock.Random.ctitle(2));
    }
    return result;
}

function getCharts(size) {
    var result = [];
    for (var i = 0; i < size; i++) {
        result.push(getOneChart());
    }
    return result;
}

function getOneChart() {
    return {
        type: Mock.Random.pick(['line', 'bar']),
        title: "title" + Mock.Random.ctitle(4),
        x_name: "xn" + Mock.Random.ctitle(2),
        y_name: "yn" + Mock.Random.ctitle(2),
        x_axis: getRandomTitle(12),
        x_data: getRandomData(12)
    };
}

var Charts = {
    "charts": getCharts(4),
    "limit": [2015, 2016, 2017]
};

console.log("apiresult");
console.log(Charts);

exports.default = Charts;

/***/ }),
/* 151 */
/***/ (function(module, exports, __webpack_require__) {

"use strict";


Object.defineProperty(exports, "__esModule", {
    value: true
});

var _from = __webpack_require__(69);

var _from2 = _interopRequireDefault(_from);

var _set = __webpack_require__(154);

var _set2 = _interopRequireDefault(_set);

var _mockjs = __webpack_require__(4);

var _mockjs2 = _interopRequireDefault(_mockjs);

var _routes = __webpack_require__(57);

var _routes2 = _interopRequireDefault(_routes);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var router_result = new _set2.default();
function getAllRouter(imputrouters) {
    for (var key in imputrouters) {
        var item = imputrouters[key];
        router_result.add(item.path);
        console.log(item.path);
        if (item.children) {
            getAllRouter(item.children);
        }
    }
}

getAllRouter(_routes2.default);
router_result = (0, _from2.default)(router_result);
console.log(router_result);
console.log(router_result.entries());

function getKdvArr() {
    var result = [];
    for (var i = 0; i < 4; i++) {
        var obj = {
            key: _mockjs2.default.Random.ctitle(4),
            value: _mockjs2.default.Random.integer(1, 10000),
            schema: _mockjs2.default.Random.pick(router_result)
        };
        result.push(obj);
    }
    return result;
}

var Home = {
    base_data: getKdvArr(),
    slide_data: getKdvArr(),
    recent_team_info: {
        team_date: "",
        team_id: "",
        traffic_no: "",
        pick_up_time: "",
        driver_phone: "",
        hotel_phone: "",
        schema: ""
    }
};

exports.default = Home;

/***/ }),
/* 152 */,
/* 153 */,
/* 154 */,
/* 155 */,
/* 156 */,
/* 157 */,
/* 158 */,
/* 159 */,
/* 160 */,
/* 161 */,
/* 162 */,
/* 163 */,
/* 164 */,
/* 165 */,
/* 166 */,
/* 167 */,
/* 168 */,
/* 169 */,
/* 170 */,
/* 171 */,
/* 172 */,
/* 173 */,
/* 174 */,
/* 175 */,
/* 176 */,
/* 177 */,
/* 178 */,
/* 179 */,
/* 180 */,
/* 181 */,
/* 182 */,
/* 183 */,
/* 184 */,
/* 185 */,
/* 186 */,
/* 187 */,
/* 188 */,
/* 189 */,
/* 190 */,
/* 191 */,
/* 192 */,
/* 193 */,
/* 194 */,
/* 195 */,
/* 196 */,
/* 197 */,
/* 198 */,
/* 199 */,
/* 200 */,
/* 201 */,
/* 202 */,
/* 203 */,
/* 204 */,
/* 205 */,
/* 206 */,
/* 207 */,
/* 208 */,
/* 209 */,
/* 210 */,
/* 211 */,
/* 212 */,
/* 213 */,
/* 214 */,
/* 215 */,
/* 216 */,
/* 217 */,
/* 218 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 219 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 220 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 221 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 222 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 223 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 224 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 225 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 226 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 227 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 228 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 229 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 230 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 231 */
/***/ (function(module, exports) {

// removed by extract-text-webpack-plugin

/***/ }),
/* 232 */,
/* 233 */,
/* 234 */,
/* 235 */,
/* 236 */,
/* 237 */,
/* 238 */,
/* 239 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(227)

var Component = __webpack_require__(5)(
  /* script */
  null,
  /* template */
  __webpack_require__(258),
  /* scopeId */
  "data-v-bd760d96",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 240 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(218)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(122),
  /* template */
  __webpack_require__(249),
  /* scopeId */
  "data-v-0dc4d752",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 241 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(224)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(123),
  /* template */
  __webpack_require__(255),
  /* scopeId */
  "data-v-6e8a0cf4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 242 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(221)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(124),
  /* template */
  __webpack_require__(252),
  /* scopeId */
  "data-v-2a3eeb2c",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 243 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(225)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(125),
  /* template */
  __webpack_require__(256),
  /* scopeId */
  "data-v-b3f5e0f4",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 244 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(223)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(126),
  /* template */
  __webpack_require__(254),
  /* scopeId */
  "data-v-5eb89b22",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 245 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(220)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(127),
  /* template */
  __webpack_require__(251),
  /* scopeId */
  "data-v-1fa83336",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 246 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(228)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(128),
  /* template */
  __webpack_require__(259),
  /* scopeId */
  "data-v-c4990520",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 247 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(229)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(131),
  /* template */
  __webpack_require__(260),
  /* scopeId */
  "data-v-c905c4ea",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 248 */
/***/ (function(module, exports, __webpack_require__) {


/* styles */
__webpack_require__(231)
__webpack_require__(230)

var Component = __webpack_require__(5)(
  /* script */
  __webpack_require__(132),
  /* template */
  __webpack_require__(261),
  /* scopeId */
  "data-v-f138942a",
  /* cssModules */
  null
)

module.exports = Component.exports


/***/ }),
/* 249 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-row', {
    staticClass: "container"
  }, [_c('el-col', {
    staticClass: "header",
    attrs: {
      "span": 24
    }
  }, [_c('el-col', {
    staticClass: "logo",
    class: _vm.collapsed ? 'logo-collapse-width' : 'logo-width',
    attrs: {
      "span": 10
    }
  }, [_vm._v("\n            " + _vm._s(_vm.collapsed ? '' : _vm.sysName) + "\n        ")]), _vm._v(" "), _c('el-col', {
    attrs: {
      "span": 10
    }
  }, [_c('div', {
    staticClass: "tools",
    on: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.collapse($event)
      }
    }
  }, [_c('i', {
    staticClass: "fa fa-align-justify"
  })])]), _vm._v(" "), _c('el-col', {
    staticClass: "userinfo",
    attrs: {
      "span": 4
    }
  }, [_c('el-dropdown', {
    attrs: {
      "trigger": "hover"
    }
  }, [_c('span', {
    staticClass: "el-dropdown-link userinfo-inner"
  }, [_c('img', {
    attrs: {
      "src": this.sysUserAvatar
    }
  }), _vm._v(" " + _vm._s(_vm.sysUserName))]), _vm._v(" "), _c('el-dropdown-menu', {
    attrs: {
      "slot": "dropdown"
    },
    slot: "dropdown"
  }, [_c('el-dropdown-item', [_vm._v("我的消息")]), _vm._v(" "), _c('el-dropdown-item', [_vm._v("设置")]), _vm._v(" "), _c('el-dropdown-item', {
    attrs: {
      "divided": ""
    },
    nativeOn: {
      "click": function($event) {
        return _vm.logout($event)
      }
    }
  }, [_vm._v("退出登录")])], 1)], 1)], 1)], 1), _vm._v(" "), _c('el-col', {
    staticClass: "main",
    attrs: {
      "span": 24
    }
  }, [_c('aside', {
    class: _vm.collapsed ? 'menu-collapsed' : 'menu-expanded'
  }, [_c('el-menu', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (!_vm.collapsed),
      expression: "!collapsed"
    }],
    staticClass: "el-menu-vertical-demo",
    attrs: {
      "default-active": _vm.$route.path,
      "unique-opened": "",
      "router": ""
    },
    on: {
      "open": _vm.handleopen,
      "close": _vm.handleclose,
      "select": _vm.handleselect
    }
  }, [_c('el-menu-item', {
    key: '/',
    attrs: {
      "index": '/'
    }
  }, [_vm._v("个人主页")]), _vm._v(" "), _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? [(!item.leaf) ? _c('el-submenu', {
      attrs: {
        "index": index + ''
      }
    }, [_c('template', {
      slot: "title"
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.name))]), _vm._v(" "), _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('el-menu-item', {
        key: child.path,
        attrs: {
          "index": child.path
        }
      }, [_vm._v(_vm._s(child.name) + "\n                        ")]) : _vm._e()
    })], 2) : _vm._e(), _vm._v(" "), (item.leaf && item.children.length > 0) ? _c('el-menu-item', {
      attrs: {
        "index": item.children[0].path
      }
    }, [_c('i', {
      class: item.iconCls
    }), _vm._v(_vm._s(item.children[0].name) + "\n                    ")]) : _vm._e()] : _vm._e()
  })], 2), _vm._v(" "), _c('ul', {
    directives: [{
      name: "show",
      rawName: "v-show",
      value: (_vm.collapsed),
      expression: "collapsed"
    }],
    ref: "menuCollapsed",
    staticClass: "el-menu el-menu-vertical-demo collapsed"
  }, _vm._l((_vm.$router.options.routes), function(item, index) {
    return (!item.hidden) ? _c('li', {
      staticClass: "el-submenu item"
    }, [(!item.leaf) ? [_c('div', {
      staticClass: "el-submenu__title",
      staticStyle: {
        "padding-left": "20px"
      },
      on: {
        "mouseover": function($event) {
          _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          _vm.showMenu(index, false)
        }
      }
    }, [_c('i', {
      class: item.iconCls
    })]), _vm._v(" "), _c('ul', {
      staticClass: "el-menu submenu",
      class: 'submenu-hook-' + index,
      on: {
        "mouseover": function($event) {
          _vm.showMenu(index, true)
        },
        "mouseout": function($event) {
          _vm.showMenu(index, false)
        }
      }
    }, _vm._l((item.children), function(child) {
      return (!child.hidden) ? _c('li', {
        key: child.path,
        staticClass: "el-menu-item",
        class: _vm.$route.path === child.path ? 'is-active' : '',
        staticStyle: {
          "padding-left": "40px"
        },
        on: {
          "click": function($event) {
            _vm.$router.push(child.path)
          }
        }
      }, [_vm._v(_vm._s(child.name) + "\n                            ")]) : _vm._e()
    }))] : [_c('ul', [_c('li', {
      staticClass: "el-submenu"
    }, [_c('div', {
      staticClass: "el-submenu__title el-menu-item",
      class: _vm.$route.path === item.children[0].path ? 'is-active' : '',
      staticStyle: {
        "height": "56px",
        "line-height": "56px",
        "padding": "0 20px"
      },
      on: {
        "click": function($event) {
          _vm.$router.push(item.children[0].path)
        }
      }
    })])])]], 2) : _vm._e()
  }))], 1), _vm._v(" "), _c('section', {
    staticClass: "content-container"
  }, [_c('div', {
    staticClass: "grid-content bg-purple-light"
  }, [_c('el-col', {
    staticClass: "breadcrumb-container",
    attrs: {
      "span": 24
    }
  }, [_c('strong', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.$route.name))]), _vm._v(" "), _c('el-breadcrumb', {
    staticClass: "breadcrumb-inner",
    attrs: {
      "separator": "/"
    }
  }, _vm._l((_vm.$route.matched), function(item) {
    return _c('el-breadcrumb-item', {
      key: item.path
    }, [_vm._v("\n                            " + _vm._s(item.name) + "\n                        ")])
  }))], 1), _vm._v(" "), _c('el-col', {
    staticClass: "content-wrapper",
    attrs: {
      "span": 24
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view', {
    key: _vm.key
  })], 1)], 1)], 1)])])], 1)
},staticRenderFns: []}

/***/ }),
/* 250 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    attrs: {
      "id": "app"
    }
  }, [_c('transition', {
    attrs: {
      "name": "fade",
      "mode": "out-in"
    }
  }, [_c('router-view')], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 251 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('p', {
    staticClass: "table_title"
  }, [_vm._v(_vm._s(_vm.title))]), _vm._v(" "), _c('el-table', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.srcdata,
      "highlight-current-row": ""
    },
    on: {
      "row-click": _vm.row_click
    }
  }, [_c('el-table-column', {
    attrs: {
      "prop": _vm.fieldmap[0].key,
      "label": _vm.fieldmap[0].name,
      "min-width": _vm.fieldmap[0].width
    }
  }), _vm._v(" "), _vm._l((_vm.fieldmap.slice(1)), function(item) {
    return _c('el-table-column', {
      key: item.key,
      attrs: {
        "prop": item.key,
        "label": item.name,
        "width": item.width
      }
    })
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 252 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-row', [_c('ValueCardGroup', {
    attrs: {
      "data": _vm.base_data
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('ValueCardGroup', {
    attrs: {
      "data": _vm.slide_data
    }
  })], 1), _vm._v(" "), _c('el-row', [_c('el-select', {
    on: {
      "change": _vm.getChartData
    },
    model: {
      value: (_vm.selected_year),
      callback: function($$v) {
        _vm.selected_year = $$v
      },
      expression: "selected_year"
    }
  }, _vm._l((_vm.limite_data), function(item) {
    return _c('el-option', {
      attrs: {
        "label": item,
        "value": item
      }
    })
  })), _vm._v(" "), _vm._l((_vm.charts), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": 24
      }
    }, [_c('SingleChart', {
      attrs: {
        "title": item.title,
        "chart_type": item.type,
        "x_name": item.x_name,
        "y_name": item.y_name,
        "x_axis": item.x_data,
        "x_data": item.y_data,
        "is_loading": _vm.chart_loading,
        "more_info": item.more_info
      }
    })], 1)]
  })], 2), _vm._v(" "), _c('HomeBody', {
    attrs: {
      "table_list": _vm.tables
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 253 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_vm._l((_vm.card_data), function(item) {
    return [_c('el-col', {
      attrs: {
        "span": _vm.card_col_size
      }
    }, [_c('value-card', {
      staticClass: "value-card",
      attrs: {
        "cardname": item.key,
        "cardvalue": item.value,
        "linkto": item.scheme
      }
    })], 1)]
  })], 2)
},staticRenderFns: []}

/***/ }),
/* 254 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    staticClass: "numberCard",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "bordered": "false"
    }
  }, [_c('div', {
    staticClass: "iconWrap"
  }), _vm._v(" "), _c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cardname))]), _vm._v(" "), _c('p', {
    staticClass: "number"
  }, [_vm._v(_vm._s(_vm.cardvalue))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 255 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('el-form', {
    ref: "ruleForm2",
    staticClass: "demo-ruleForm login-container",
    attrs: {
      "model": _vm.ruleForm2,
      "rules": _vm.rules2,
      "label-position": "left",
      "label-width": "0px"
    }
  }, [_c('h3', {
    staticClass: "title"
  }, [_vm._v("系统登录")]), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "account"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "text",
      "auto-complete": "off",
      "placeholder": "用户名"
    },
    model: {
      value: (_vm.ruleForm2.account),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "account", $$v)
      },
      expression: "ruleForm2.account"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "prop": "pwd"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off",
      "placeholder": "密码"
    },
    model: {
      value: (_vm.ruleForm2.pwd),
      callback: function($$v) {
        _vm.$set(_vm.ruleForm2, "pwd", $$v)
      },
      expression: "ruleForm2.pwd"
    }
  })], 1), _vm._v(" "), _c('el-checkbox', {
    staticClass: "remember",
    attrs: {
      "checked": ""
    },
    model: {
      value: (_vm.checked),
      callback: function($$v) {
        _vm.checked = $$v
      },
      expression: "checked"
    }
  }, [_vm._v("记住密码")]), _vm._v(" "), _c('el-form-item', {
    staticStyle: {
      "width": "100%"
    }
  }, [_c('el-button', {
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "type": "primary",
      "loading": _vm.logining
    },
    nativeOn: {
      "click": function($event) {
        $event.preventDefault();
        return _vm.handleSubmit2($event)
      }
    }
  }, [_vm._v("登录")])], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 256 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticStyle: {
      "display": "flex",
      "flex-direction": "row",
      "flex-wrap": "nowrap"
    }
  }, [_c('div', [(false) ? _c('el-col', {
    staticClass: "toolbar",
    staticStyle: {
      "padding-bottom": "0px"
    },
    attrs: {
      "span": 24
    }
  }, [_c('el-form', {
    attrs: {
      "inline": true,
      "model": _vm.filters
    }
  }, [_c('el-form-item', [_c('el-input', {
    attrs: {
      "placeholder": "姓名"
    },
    model: {
      value: (_vm.filters.name),
      callback: function($$v) {
        _vm.$set(_vm.filters, "name", $$v)
      },
      expression: "filters.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.getUsers
    }
  }, [_vm._v("查询")])], 1), _vm._v(" "), _c('el-form-item', [_c('el-button', {
    attrs: {
      "type": "primary"
    },
    on: {
      "click": _vm.handleAdd
    }
  }, [_vm._v("新增")])], 1)], 1)], 1) : _vm._e(), _vm._v(" "), _c('el-table', {
    directives: [{
      name: "loading",
      rawName: "v-loading",
      value: (_vm.listLoading),
      expression: "listLoading"
    }],
    staticStyle: {
      "width": "100%"
    },
    attrs: {
      "data": _vm.users,
      "highlight-current-row": ""
    },
    on: {
      "selection-change": _vm.selsChange
    }
  }, [_c('el-table-column', {
    attrs: {
      "type": "selection",
      "width": "55"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "type": "index",
      "width": "60"
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "name",
      "label": "用户名",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "gender",
      "label": "性别",
      "width": "100",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "phone",
      "label": "手机",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "payStatus",
      "label": "支付状态",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "serviceStatus",
      "label": "服务状态",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sourceId",
      "label": "商家id",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "prop": "sourceName",
      "label": "商家名称",
      "width": "150",
      "sortable": ""
    }
  }), _vm._v(" "), _c('el-table-column', {
    attrs: {
      "label": "操作",
      "min-width": "150"
    },
    scopedSlots: _vm._u([{
      key: "default",
      fn: function(scope) {
        return [_c('el-button', {
          attrs: {
            "size": "small"
          },
          on: {
            "click": function($event) {
              _vm.goDetail(scope.$index, scope.row)
            }
          }
        }, [_vm._v("详情")])]
      }
    }])
  })], 1), _vm._v(" "), _c('el-col', {
    staticClass: "toolbar",
    attrs: {
      "span": 24
    }
  }, [_c('el-pagination', {
    staticStyle: {
      "float": "right"
    },
    attrs: {
      "layout": "prev, pager, next",
      "page-size": 20,
      "total": _vm.total
    },
    on: {
      "current-change": _vm.handleCurrentChange
    }
  })], 1)], 1)]), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "编辑",
      "visible": _vm.editFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.editFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "editForm",
    attrs: {
      "model": _vm.editForm,
      "label-width": "80px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.name),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "name", $$v)
      },
      expression: "editForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "nickname", $$v)
      },
      expression: "editForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "disabled": "",
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.password),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "password", $$v)
      },
      expression: "editForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.editForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "gender", $$v)
      },
      expression: "editForm.gender"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "male"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "female"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "mobile", $$v)
      },
      expression: "editForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "identify_no"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.editForm.identify_no),
      callback: function($$v) {
        _vm.$set(_vm.editForm, "identify_no", $$v)
      },
      expression: "editForm.identify_no"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.editFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.editLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.editSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1), _vm._v(" "), _c('el-dialog', {
    attrs: {
      "title": "新增",
      "visible": _vm.addFormVisible,
      "close-on-click-modal": false
    },
    on: {
      "update:visible": function($event) {
        _vm.addFormVisible = $event
      }
    }
  }, [_c('el-form', {
    ref: "addForm",
    attrs: {
      "model": _vm.addForm,
      "label-width": "80px",
      "rules": _vm.rules
    }
  }, [_c('el-form-item', {
    attrs: {
      "label": "姓名",
      "prop": "name"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.name),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "name", $$v)
      },
      expression: "addForm.name"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "用户名",
      "prop": "nickname"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.nickname),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "nickname", $$v)
      },
      expression: "addForm.nickname"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "密码",
      "prop": "password"
    }
  }, [_c('el-input', {
    attrs: {
      "type": "password",
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.password),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "password", $$v)
      },
      expression: "addForm.password"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "性别",
      "prop": "gender"
    }
  }, [_c('el-radio-group', {
    model: {
      value: (_vm.addForm.gender),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "gender", $$v)
      },
      expression: "addForm.gender"
    }
  }, [_c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "male"
    }
  }, [_vm._v("男")]), _vm._v(" "), _c('el-radio', {
    staticClass: "radio",
    attrs: {
      "label": "female"
    }
  }, [_vm._v("女")])], 1)], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "电话",
      "prop": "mobile"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.mobile),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "mobile", $$v)
      },
      expression: "addForm.mobile"
    }
  })], 1), _vm._v(" "), _c('el-form-item', {
    attrs: {
      "label": "身份证号",
      "prop": "identify_no"
    }
  }, [_c('el-input', {
    attrs: {
      "auto-complete": "off"
    },
    model: {
      value: (_vm.addForm.identify_no),
      callback: function($$v) {
        _vm.$set(_vm.addForm, "identify_no", $$v)
      },
      expression: "addForm.identify_no"
    }
  })], 1)], 1), _vm._v(" "), _c('div', {
    staticClass: "dialog-footer",
    attrs: {
      "slot": "footer"
    },
    slot: "footer"
  }, [_c('el-button', {
    nativeOn: {
      "click": function($event) {
        _vm.addFormVisible = false
      }
    }
  }, [_vm._v("取消")]), _vm._v(" "), _c('el-button', {
    attrs: {
      "type": "primary",
      "loading": _vm.addLoading
    },
    nativeOn: {
      "click": function($event) {
        return _vm.addSubmit($event)
      }
    }
  }, [_vm._v("提交")])], 1)], 1)], 1)
},staticRenderFns: []}

/***/ }),
/* 257 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('el-card', {
    staticClass: "numberCard",
    staticStyle: {
      "padding": "0"
    },
    attrs: {
      "bordered": "false"
    },
    nativeOn: {
      "click": function($event) {
        _vm.go()
      }
    }
  }, [_c('div', {
    staticClass: "content"
  }, [_c('p', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.cardname) + _vm._s(_vm.addMaohao(_vm.cardvalue)))])])])], 1)
},staticRenderFns: []}

/***/ }),
/* 258 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('p', {
    staticClass: "page-container"
  }, [_vm._v("404 page not found")])
},staticRenderFns: []}

/***/ }),
/* 259 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticClass: "chart-container"
  }, [_c('div', {
    staticStyle: {
      "width": "100%",
      "height": "400px"
    },
    attrs: {
      "id": _vm.random_id
    }
  }), _vm._v(" "), _c('ValueCardGroup', {
    attrs: {
      "data": _vm.more_info
    }
  })], 1)
},staticRenderFns: []}

/***/ }),
/* 260 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('el-row', {
    staticClass: "row"
  }, [_vm._l((_vm.table_data_list), function(item) {
    return [_c('el-col', {
      staticClass: "col",
      attrs: {
        "span": 12
      }
    }, [_c('SimpleTable', {
      attrs: {
        "title": item.name,
        "srcdata": item.data,
        "config": item.config
      }
    })], 1)]
  })], 2)], 1)
},staticRenderFns: []}

/***/ }),
/* 261 */
/***/ (function(module, exports) {

module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', {
    staticStyle: {
      "padding-top": "10px"
    }
  }, [_c('el-upload', {
    staticClass: "upload-demo",
    attrs: {
      "show-file-list": false,
      "on-success": _vm.onUploadSuccess,
      "drag": "",
      "file-list": _vm.fileList,
      "action": "/api/upload_file",
      "multiple": ""
    }
  }, [_c('i', {
    staticClass: "el-icon-upload"
  }), _vm._v(" "), _c('div', {
    staticClass: "el-upload__text"
  }, [_vm._v("将文件拖到此处，或"), _c('em', [_vm._v("点击上传")])]), _vm._v(" "), _c('div', {
    staticClass: "el-upload__tip",
    attrs: {
      "slot": "tip"
    },
    slot: "tip"
  }, [_vm._v("只能上传csv文件")])]), _vm._v(" "), _vm._l((_vm.fileList), function(item) {
    return _c('el-card', {
      staticClass: "box-card"
    }, [_c('div', {
      staticStyle: {
        "width": "100%",
        "height": "100%"
      },
      on: {
        "click": function($event) {
          _vm.goDownload(item['name'])
        }
      }
    }, [_vm._v("\n            " + _vm._s(item['name']) + "\n        ")])])
  })], 2)
},staticRenderFns: []}

/***/ })
],[135]);


// WEBPACK FOOTER //
// static/js/app.3b13ac4ea7882b3ff3d7.js